import React from 'react';
export default function TriangleCrewCut({ light, dark }) {
  return (
<><path d="M16.92 5.503c-3.062.006-7.843 3.514-9.07 3.122-1.09-.346-2.16-2.66-1.746-3.394 1.067-1.896 20.64-2.11 21.747-.239.323.545-.556 3.1-1.603 3.452-2.546.859-5.836-2.949-9.328-2.941z" fill={light}/></>); }
